import { useState, useEffect } from "react";
import { useToast } from '../../contexts/ToastContext';

const API_URL = process.env.REACT_APP_BACKEND_BASE_URL + '/api/groups';

const useGroups = () => {
  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { showToast } = useToast(); 

  const fetchGroups = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      setGroups(data);
      setError(null);
    } catch (err) {
      setError("שגיאה בטעינת הקבוצות");
    }
    setIsLoading(false);
  };

  const addGroup = async (group) => {
    try {
      const payload = { ...group };
      
      if (group.limitAmountEnabled && group.autoApprovalMaxAmount !== '' && group.autoApprovalMaxAmount !== undefined && group.autoApprovalMaxAmount !== null) {
        payload.autoApprovalMaxAmount = group.autoApprovalMaxAmount;
      } else {
        payload.autoApprovalMaxAmount = null;
      }
      
      if (group.autoApprovalDelayHours !== undefined && group.autoApprovalDelayHours !== null) {
        payload.autoApprovalDelayHours = group.autoApprovalDelayHours;
      } else {
        payload.autoApprovalDelayHours = 0;
      }
      
      // 🆕 ברירת מחדל: 3 ימים
      payload.requiresAttentionDaysThreshold = group.requiresAttentionDaysThreshold || 3;
      
      await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      showToast("הקבוצה נוספה בהצלחה", "success");
      fetchGroups();
    } catch (err) {
      showToast("שגיאה בהוספת קבוצה", "error");
    }
  };

  const updateGroup = async (groupId, group) => {
    try {
      const payload = { ...group };
      
      if (group.limitAmountEnabled && group.autoApprovalMaxAmount !== '' && group.autoApprovalMaxAmount !== undefined && group.autoApprovalMaxAmount !== null) {
        payload.autoApprovalMaxAmount = group.autoApprovalMaxAmount;
      } else {
        payload.autoApprovalMaxAmount = null;
      }
      
      if (group.autoApprovalDelayHours !== undefined && group.autoApprovalDelayHours !== null) {
        payload.autoApprovalDelayHours = group.autoApprovalDelayHours;
      } else {
        payload.autoApprovalDelayHours = 0;
      }
      
      // 🆕 תמיכה בעדכון סף הימים
      payload.requiresAttentionDaysThreshold = group.requiresAttentionDaysThreshold || 3;
      
      await fetch(`${API_URL}/${groupId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      showToast("הקבוצה עודכנה בהצלחה", "success");
      fetchGroups();
    } catch (err) {
      showToast("שגיאה בעדכון קבוצה", "error");
    }
  };

  const deleteGroup = async (groupId) => {
    try {
      await fetch(`${API_URL}/${groupId}`, {
        method: 'DELETE',
      });
      showToast("הקבוצה נמחקה בהצלחה", "success");
      fetchGroups();
    } catch (err) {
      showToast("שגיאה במחיקת קבוצה", "error");
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  return {
    groups,
    isLoading,
    error,
    fetchGroups,
    addGroup,
    updateGroup,
    deleteGroup
  };
};

export default useGroups;